import React from 'react';
import { PasswordResetFormContainer } from '@/components/pages/PasswordReset/Index/PasswordResetForm';

export const PasswordResetPage: React.FC = () => {
  return <PasswordResetFormContainer />;
};
